var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#FCFDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#CACED4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23223 7.56622C9.70107 7.09738 10.337 6.83398 11 6.83398H17.6667C17.8877 6.83398 18.0996 6.92178 18.2559 7.07806L23.2559 12.0781C23.4122 12.2343 23.5 12.4463 23.5 12.6673V22.6673C23.5 23.3304 23.2366 23.9662 22.7678 24.4351C22.2989 24.9039 21.663 25.1673 21 25.1673H11C10.337 25.1673 9.70107 24.9039 9.23223 24.4351C8.76339 23.9662 8.5 23.3304 8.5 22.6673V9.33398C8.5 8.67094 8.76339 8.03506 9.23223 7.56622ZM11 8.50065C10.779 8.50065 10.567 8.58845 10.4107 8.74473C10.2545 8.90101 10.1667 9.11297 10.1667 9.33398V22.6673C10.1667 22.8883 10.2545 23.1003 10.4107 23.2566C10.567 23.4129 10.779 23.5007 11 23.5007H21C21.221 23.5007 21.433 23.4129 21.5893 23.2566C21.7455 23.1003 21.8333 22.8883 21.8333 22.6673V13.5007H17.6667C17.2065 13.5007 16.8334 13.1276 16.8334 12.6673L16.8333 8.50065H11ZM18.5 9.67917L20.6548 11.834H18.5L18.5 9.67917ZM16 15.1673C16.4603 15.1673 16.8333 15.5404 16.8333 16.0006V17.6673H18.5C18.9603 17.6673 19.3333 18.0404 19.3333 18.5006C19.3333 18.9609 18.9603 19.334 18.5 19.334H16.8333V21.0006C16.8333 21.4609 16.4603 21.834 16 21.834C15.5398 21.834 15.1667 21.4609 15.1667 21.0006V19.334H13.5C13.0398 19.334 12.6667 18.9609 12.6667 18.5006C12.6667 18.0404 13.0398 17.6673 13.5 17.6673H15.1667V16.0006C15.1667 15.5404 15.5398 15.1673 16 15.1673Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.700ce8b891c24b2c3a29e1104093e426.svg";
export { ForwardRef as ReactComponent };